import type {
  ChatSessionVo,
  CreateSessionDTO,
  // CreateSessionVO,
  GetSessionListParams,
} from './types';
import { del, get, post, put } from '@/utils/request';
import { getConversations } from '../chat';

export function get_session_list(params: GetSessionListParams) {
  // 新接口不需要参数，直接调用
  return getConversations().then((response) => {
    // 新接口直接返回 rows，无需转换
    if (response.code === 200 && response.rows) {
      return {
        ...response,
        rows: response.rows.map((item: ChatSessionVo) => ({
          ...item,
          userId: params.userId || item.userId,
        })),
      };
    }
    return {
      ...response,
      rows: [],
    };
  });
}

export function create_session(data: CreateSessionDTO) {
  return post('/system/session', data).json();
}

export function update_session(data: ChatSessionVo) {
  return put('/system/session', data).json();
}

export function get_session(id: string) {
  return get<ChatSessionVo>(`/system/session/${id}`).json();
}

export function delete_session(ids: string | number | Array<string | number>) {
  let formatted = '';
  if (Array.isArray(ids)) {
    formatted = ids.join(',');
  } else {
    formatted = String(ids);
  }
  const pathParam = encodeURIComponent(formatted);
  return del(`/system/session/${pathParam}`).json();
}
